













import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-list-banner',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop() private index: number;
  @Prop() private bannerData!: object;
  @Prop() private bannerDevice!: string;
}
